import { createTopicSelector } from "entities/topics/selectors";
import type { RootState } from "types";

export const getTmId = (state: RootState) => state.domains.transformationMap.id;

const getTmSelectedInnerNodeId = (state: RootState) => state.domains.transformationMap.selectedInnerNodeId;

export const getTmSelectedOuterNodeId = (state: RootState) => state.domains.transformationMap.selectedOuterNodeId;

export const getTmSelectedId = (state: RootState) => getTmSelectedInnerNodeId(state) ?? getTmId(state);

export const getTmTopic = (state: RootState) => {
  const id = getTmId(state);
  return id === undefined ? undefined : createTopicSelector(id)(state);
};

export const getTmSelectedInnerNode = (state: RootState) => {
  const id = getTmSelectedInnerNodeId(state);
  return id === undefined ? undefined : createTopicSelector(id)(state);
};

export const getTmSelectedOuterNode = (state: RootState) => {
  const id = getTmSelectedOuterNodeId(state);
  return id === undefined ? undefined : createTopicSelector(id)(state);
};

export const getTmSelectedTopic = (state: RootState) => {
  const id = getTmSelectedId(state);
  return id === undefined ? undefined : createTopicSelector(id)(state);
};

export const getTmHistory = (state: RootState) => state.domains.transformationMap.history;

export const getTmEditMode = ({ domains }: RootState) => domains.transformationMap.isEditingMode;

export const getIsTmPending = (state: RootState) => state.domains.transformationMap.isPending;
